import React, { useState, useEffect, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateCompany = (props) => {
    const [CompanyName, setCompanyName] = useState('');
    const [CompanyCode, setCompanyCode] = useState('');
    const [Website, setWebsite] = useState('');
    const [EmailID, setEmailID] = useState('');
    const [GSTIN, setGSTIN] = useState('');
    const [PAN, setPAN] = useState('');
    const [CIN, setCIN] = useState('');
    const [Address, setAddress] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);

    const validationSchema = Yup.object({
        CompanyName: Yup.string().required('Required!'),
        CompanyCode: Yup.string().required('Required!'),
        // GSTIN: Yup.string().required('Required!'),
        PAN: Yup.string().required('Required!'),
        CIN: Yup.string().required('Required!')
    });

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);


    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };


    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Company');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.CompanyName);
        bodyFormData.append("Value2", values.CompanyCode);
        bodyFormData.append("Value3", values.Website);
        bodyFormData.append("Value4", values.EmailID);
        bodyFormData.append("Value5", values.GSTIN);
        bodyFormData.append("Value6", values.PAN);
        bodyFormData.append("Value7", values.Address);
        bodyFormData.append("Value8", values.CIN);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Company');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    const BankData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Company');
        fetchComboData("Primary/List", bodyFormData);
    }

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])



    useEffect(() => {
        if (responseGetData.length > 0) {
            setCompanyName(responseGetData[0].CompanyName === null ? "" : responseGetData[0].CompanyName);
            setCompanyCode(responseGetData[0].CompanyCode === null ? "" : responseGetData[0].CompanyCode);
            setWebsite(responseGetData[0].Website === null ? "" : responseGetData[0].Website);
            setEmailID(responseGetData[0].EmailID === null ? "" : responseGetData[0].EmailID);
            setGSTIN(responseGetData[0].GSTIN === null ? "" : responseGetData[0].GSTIN);
            setPAN(responseGetData[0].PAN === null ? "" : responseGetData[0].PAN);
            setAddress(responseGetData[0].Address === null ? "" : responseGetData[0].Address);
            setCIN(responseGetData[0].CIN === null ? "" : responseGetData[0].CIN);

        }
    }, [responseGetData]);

    useEffect(() => {
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ CompanyName: CompanyName, CompanyCode: CompanyCode, Website: Website, EmailID: EmailID, GSTIN: GSTIN, PAN: PAN, CIN: CIN, Address: Address }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Company Name'
                                    name='CompanyName'
                                    ref={ref}
                                    value={CompanyName}
                                    onChange={(e) => {
                                        setCompanyName(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Company Code'
                                    name='CompanyCode'
                                    onChange={(e) => setCompanyCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Website'
                                    name='Website'
                                    onChange={(e) => setWebsite(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Email ID'
                                    name='EmailID'
                                    onChange={(e) => setEmailID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 5 }}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='GST IN/Additional Info'
                                    name='GSTIN'
                                    ref={ref}
                                    value={GSTIN}
                                    onChange={(e) => {
                                        setGSTIN(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='PAN'
                                    name='PAN'
                                    ref={ref}
                                    value={PAN}
                                    onChange={(e) => {
                                        setPAN(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 5 }}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='CIN/Additional Info'
                                    name='CIN'
                                    ref={ref}
                                    value={CIN}
                                    onChange={(e) => {
                                        setCIN(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Address'
                                    name='Address'
                                    ref={ref}
                                    value={Address}
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateCompany;
